import a from "react";
import { VisuallyHidden as v } from "../../../VisuallyHidden/VisuallyHidden.js";
import { LogoOLX as b } from "../../../LogoOLX/LogoOLX.js";
import { cls as O } from "../../../../helpers/cls.js";
import "@olxbr/ds-icons";
import { sendClickEvent as y } from "../../../Header/utils/sendClickEvent.js";
import { Link as k } from "../../../Link/Link.js";
var _ = Object.defineProperty,
  h = Object.defineProperties,
  x = Object.getOwnPropertyDescriptors,
  l = Object.getOwnPropertySymbols,
  p = Object.prototype.hasOwnProperty,
  s = Object.prototype.propertyIsEnumerable,
  f = (e, r, o) => r in e ? _(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : e[r] = o,
  m = (e, r) => {
    for (var o in r || (r = {})) p.call(r, o) && f(e, o, r[o]);
    if (l) for (var o of l(r)) s.call(r, o) && f(e, o, r[o]);
    return e;
  },
  E = (e, r) => h(e, x(r)),
  P = (e, r) => {
    var o = {};
    for (var t in e) p.call(e, t) && r.indexOf(t) < 0 && (o[t] = e[t]);
    if (e != null && l) for (var t of l(e)) r.indexOf(t) < 0 && s.call(e, t) && (o[t] = e[t]);
    return o;
  };
const j = e => {
  const {
      tag: r = "span",
      goBack: o,
      title: t,
      logoProps: n,
      inverted: d
    } = e,
    i = n != null ? n : {},
    {
      onClick: c,
      tag: L
    } = i,
    u = P(i, ["onClick", "tag"]);
  return a.createElement(r === "a" ? k : r, m(E(m({}, r === "a" && {
    href: "https://olx.com.br"
  }), {
    "data-ds-component": "DS-FocusHeaderLogo",
    onClick: g => {
      y("logo"), c == null || c(g);
    },
    className: O("olx-focus-header__logo", "ds-primary-link", o && t && "olx-focus-header__goback")
  }), u), r !== "span" && a.createElement(v, null, "P\xE1gina inicial"), a.createElement("span", {
    className: "olx-focus-header__logo-container",
    "aria-hidden": !0
  }, a.createElement(b, {
    variation: d ? "white-o" : "default"
  })));
};
export { j as FocusHeaderLogo };